import { Field } from "@/shared/ui/form-field"
import { VariableSelect } from "@/shared/ui/variable-select"
import type { EditorProps } from "../editor-props"
import { readString, withField } from "../editor-props"
import { issuesAt } from "../issues-text"

export function StartEditor({ config, onChange, issues, draft }: EditorProps) {
	return (
		<Field
			label="Параметр ссылки t.me/бот?start=…"
			issues={issuesAt(issues, "saveStartPayloadTo")}
			hint="С этого блока начинается воронка. Параметр ссылки всегда доступен как startPayload."
		>
			<VariableSelect
				aria-label="Сохранить параметр в переменную"
				value={readString(config, "saveStartPayloadTo")}
				onChange={(name) => onChange(withField(config, "saveStartPayloadTo", name || undefined))}
				variables={draft.variables}
				emptyLabel="Не сохранять в переменную"
			/>
		</Field>
	)
}
